export function CargaPagina({ texto }: { texto?: string }) {
  return (
    <div
      className="flex min-h-dvh w-full items-center justify-center bg-fondo"
      role="status"
      aria-live="polite"
    >
      <span
        className="h-8 w-8 animate-spin rounded-full border-2 border-navy/15 border-t-navy"
        aria-hidden="true"
      />
      <span className="sr-only">{texto ?? 'Cargando'}</span>
    </div>
  );
}
